import types from 'helpers/constants';

export const setRegionForValidations = payload => ({
  type: types.SET_REGION_FOR_VALIDATIONS,
  payload,
});
